import React from 'react';
import { Route } from 'react-router-dom';

import { paths } from '@/config';
import { Company } from '@/components/Pages';

const CompanyRoutes = () => {
  return (
    <>
      <Route component={Company} path={paths.common.company} exact />
    </>
  );
};

export default CompanyRoutes;
